import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { useLocation } from "react-router-dom"
import { getMicrosoftConnectionStatus, getMicrosoftAuthUrl, disconnectMicrosoft } from "@/api"

export const useMicrosoftConnection = () => {
  const queryClient = useQueryClient()
  const location = useLocation()

  const statusQuery = useQuery({
    queryKey: ["microsoftConnectionStatus"],
    queryFn: getMicrosoftConnectionStatus,
    staleTime: 1000 * 60 * 5,
  })

  const connectMutation = useMutation({
    mutationFn: async () => {
      const data = await getMicrosoftAuthUrl(location.pathname)
      window.location.href = data.authUrl
    },
  })

  const disconnectMutation = useMutation({
    mutationFn: disconnectMicrosoft,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["microsoftConnectionStatus"] })
    },
  })

  return {
    isConnected: statusQuery.data?.isConnected ?? false,
    isLoading: statusQuery.isLoading,
    connect: connectMutation.mutate,
    disconnect: disconnectMutation.mutate,
    isConnecting: connectMutation.isPending,
    isDisconnecting: disconnectMutation.isPending,
  }
}
